import urls from "global/constants/UrlConstants";
import { getFileCallParams, makeCall } from "utils/service";
import { CompareInput, ContractCompareResponse } from "./ContractCompareTypesAndValidation";

/**
 * `makeCall`'s own timeout. Its timer only races the request and never aborts it, so the hook's `AbortController`
 * (`COMPARE_ABORT_MS`, 80 s) must fire first: this one is a backstop, set above it (D61).
 */
export const COMPARE_CALL_TIMEOUT_MS = 85_000;

/**
 * One compare. Only the active tab's old version goes out: `originalDocumentId` for a contract picked from the
 * user's own list, `original` for an upload. Contract text is customer data: the PostHog capture option is
 * deliberately not set here.
 *
 * `signal` is what Cancel and the abort timer use. The failure is whatever `makeCall` throws -- the parsed body with
 * `statusCode`, a `SyntaxError` for a body that is not JSON, a `TypeError` for a network failure -- and
 * `ContractCompareHelper.classifyError` makes sense of it.
 */
export const compareContracts = async (
  { revised, old }: CompareInput,
  signal: AbortSignal,
): Promise<ContractCompareResponse> => {
  const formData = new FormData();
  formData.append("revised", revised, revised.name);
  if (old.kind === "library") formData.append("originalDocumentId", old.documentId);
  else formData.append("original", old.file, old.file.name);
  // Async: the headers are built on the auth state. The Content-Type is left to the browser (the boundary).
  const callParams = await getFileCallParams("POST", formData, signal);
  return makeCall(urls.CONTRACT_COMPARE, callParams, true, {
    timeoutMs: COMPARE_CALL_TIMEOUT_MS,
  });
};
